module.exports = __webpack_public_path__ + "img/MaxxBelek.972c1c6e.png";